// extracted by mini-css-extract-plugin
module.exports = {"wraper":"shareLinkButtons-module--wraper--yREK-"};